<template>
  <div class="TagConfigPanel DetailGrid">
    <div class="DetailGrid__nav">
      <h2 class="h3 TagConfigPanel__header">
        <span>
          {{ $t('ContractorsConfigPanel.contractorManagement') }}
        </span>
      </h2>

      <div class="mt-3">
        <DataTable
          :value="contractors"
          data-key="uuid"
          class="ContractorsTable"
        >
          <Column
            field="label"
            :header="$t('ContractorsConfigPanel.name')"
          />
          <Column :header="$t('ContractorsConfigPanel.connectedProcesses')">
            <template #body="{ data }">
              <Skeleton
                v-if="isLoadingCounts"
                width="2rem"
              />
              <span v-else>{{ data.realisationCount }}</span>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <div class="DetailGrid__sidebar">
      <h4>{{ $t('ContractorsConfigPanel.aboutContractors') }}</h4>

      <p>
        {{ $t('ContractorsConfigPanel.sentence1') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Skeleton from 'primevue/skeleton'

export default {
  name: 'ContractorConfigPanel',
  components: { DataTable, Column, Skeleton },
  data() {
    return {
      isLoadingCounts: true,
    }
  },
  computed: {
    ...mapGetters('tenant', ['getContractors']),
    ...mapGetters('realisations', ['getReportingRecords']),

    contractors() {
      return [...this.getContractors]
        .map(contractor => ({
          ...contractor,
          realisationCount: this.countRecordsByContractors(contractor).length
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
    },
  },
  async created() {
    // Records loaded for reporting are cached tenant-wide, reuse them if already available //
    if (this.getReportingRecords.length) {
      this.isLoadingCounts = false
      return
    }

    try {
      const token = await this.$auth.getTokenSilently()
      await this.loadRecords({
        token,
        reporting: true,
        limit: 1000,
        project: { _id: 0, stakeholders: 1 }
      })
    } catch (e) {
      console.log(e)
    } finally {
      this.isLoadingCounts = false
    }
  },
  methods: {
    ...mapActions('realisations', ['loadRecords']),

    countRecordsByContractors (contractor) {
      return this.getReportingRecords
        .filter(record => record.stakeholders?.some(s => s.category === 'contractor' && s.uuid === contractor.uuid))
    },
  },
}
</script>

<style lang="scss">
.TagConfigPanel {

  &__header {
    display: flex;
    justify-content: space-between;
  }
}

.ContractorsTable {
  width: 100%;
}
</style>
